import { z } from 'zod';
import { apiUrl } from '../config/api';
import { apiClient } from '../lib/apiClient';
import { envelopeSchema, vendorSchema } from '../lib/schemas';

export interface Vendor {
  id: string;
  created_at?: string;
  updated_at?: string;
  created_by?: string;
  updated_by?: string;
  vendor_id?: string | null;
  vendor_name?: string | null;
  vendor_type?: string | null;
  country?: string | null;
  postal_code?: string | null;
  city?: string | null;
  street?: string | null;
  street_no?: string | null;
}

export type VendorInput = Omit<
  Vendor,
  'id' | 'created_at' | 'updated_at' | 'created_by' | 'updated_by'
>;

export const vendorService = {
  async getAll(): Promise<Vendor[]> {
    const result = await apiClient.get(apiUrl.vendors(), {
      validate: envelopeSchema('vendors', z.array(vendorSchema)),
      deduplicate: true,
      context: 'getVendors',
    });
    return result.vendors;
  },

  async create(row: VendorInput): Promise<Vendor> {
    const result = await apiClient.post(apiUrl.vendors(), row, {
      validate: envelopeSchema('vendor', vendorSchema),
      context: 'createVendor',
    });
    return result.vendor;
  },

  async update(id: string, row: VendorInput): Promise<Vendor> {
    const result = await apiClient.put(apiUrl.vendors(id), row, {
      validate: envelopeSchema('vendor', vendorSchema),
      context: 'updateVendor',
    });
    return result.vendor;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(apiUrl.vendors(id), {
      context: 'deleteVendor',
    });
  },
};
